// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Plan Page Styles */
.plan-page {
    min-height: 100vh;
    background-color: #f8fafc;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
}

.plan-loading {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    color: #64748b;
}

.plan-loading-spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #e2e8f0;
    border-top-color: #4f46e5;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.plan-geo-alert {
    max-width: 1200px;
    margin: 0 auto 1.5rem;
    padding: 1rem 1.25rem;
    border-radius: 12px;
    background: #fef3c7;
    border: 1px solid #f59e0b;
    color: #92400e;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
}

.plan-geo-alert p {
    margin: 0;
    flex: 1 1;
    min-width: 220px;
}

.plan-geo-alert-btn {
    border: none;
    border-radius: 8px;
    padding: 0.5rem 1rem;
    background: #d97706;
    color: #fff;
    font-weight: 600;
    cursor: pointer;
}

.plan-geo-alert-btn:hover {
    background: #b45309;
}

.plan-button:disabled {
    opacity: 0.55;
    cursor: not-allowed;
}

.plan-header {
    text-align: center;
    padding: 2.5rem 1.5rem 2rem;
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.plan-header h1 {
    font-size: clamp(1.5rem, 3vw, 2.25rem);
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 0.75rem;
    line-height: 1.25;
}

.gradient-text {
    background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.plan-subtitle {
    font-size: 1.125rem;
    color: #64748b;
    margin-bottom: 0.5rem;
}

.plan-region-hint {
    font-size: 0.9375rem;
    color: #64748b;
    margin-bottom: 1.5rem;
}

.plan-metrics-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.plan-metrics-list li {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    margin-bottom: 0.625rem;
    font-size: 0.875rem;
    color: #475569;
    line-height: 1.4;
}

.calculator-breakdown {
    font-size: 0.8125rem;
    color: #64748b;
    margin: 0.5rem 0 1rem;
}

.calculator-usage-breakdown {
    list-style: none;
    margin: 0 0 1.25rem;
    padding: 0;
    text-align: left;
    border-top: 1px solid #e2e8f0;
    padding-top: 1rem;
}

.calculator-usage-breakdown li {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 0.5rem;
    padding: 0.4rem 0;
    font-size: 0.8125rem;
    color: #94a3b8;
    min-height: 1.5rem;
}

.calculator-usage-breakdown li.has-usage {
    color: #64748b;
}

.calculator-usage-breakdown li.has-usage .breakdown-calc strong {
    color: #1e293b;
}

.calculator-usage-breakdown .breakdown-label {
    font-weight: 500;
    flex: 1 1 auto;
    min-width: 0;
}

.calculator-usage-breakdown .breakdown-calc {
    text-align: right;
    font-variant-numeric: tabular-nums;
    flex: 0 0 11.5rem;
    white-space: nowrap;
}

.calculator-usage-breakdown .breakdown-calc strong {
    font-weight: 600;
    color: #cbd5e1;
}

/* Billing Toggle */
.billing-toggle {
    display: inline-flex;
    align-items: center;
    gap: 0.75rem;
    background: #ffffff;
    padding: 0.5rem 1rem;
    border-radius: 2rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.billing-toggle span {
    font-size: 0.875rem;
    /* color: #94a3b8; */
    transition: color 0.2s;
}

.billing-toggle span.active {
    color: #1e293b;
    font-weight: 600;
}

.toggle-switch {
    width: 48px;
    height: 26px;
    background: #e2e8f0;
    border: none;
    border-radius: 13px;
    cursor: pointer;
    position: relative;
    transition: background 0.2s;
}

.toggle-switch:hover {
    background: #cbd5e1;
}

.toggle-slider {
    position: absolute;
    top: 3px;
    left: 3px;
    width: 20px;
    height: 20px;
    background: #ffffff;
    border-radius: 50%;
    transition: transform 0.2s;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.toggle-slider.annual {
    transform: translateX(22px);
}

.save-badge {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    color: white;
    font-size: 0.75rem;
    padding: 0.25rem 0.5rem;
    border-radius: 1rem;
    margin-left: 0.25rem;
    font-weight: 600;
}

/* Plan Cards Section */
/* ── "Your current plan" card (My Plan header) ── */
.my-plan-section {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0.5rem 1.5rem 0;
}

.my-plan-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1.5rem;
    flex-wrap: wrap;
    padding: 1.5rem 1.75rem;
    border-radius: 1rem;
    background: linear-gradient(135deg, #f5f3ff 0%, #eef2ff 100%);
    border: 1px solid #ddd6fe;
}

.my-plan-info {
    min-width: 0;
}

.my-plan-eyebrow {
    display: inline-block;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #7c3aed;
    margin-bottom: 0.35rem;
}

.my-plan-name {
    font-size: 1.5rem;
    font-weight: 700;
    color: #1e293b;
    margin: 0 0 0.25rem;
}

.my-plan-price {
    display: flex;
    align-items: baseline;
    gap: 0.25rem;
    margin-bottom: 0.35rem;
}

.my-plan-price-amount {
    font-size: 1.75rem;
    font-weight: 800;
    color: #1e293b;
    line-height: 1;
}

.my-plan-price-period {
    font-size: 0.9375rem;
    color: #64748b;
    font-weight: 500;
}

.my-plan-desc {
    color: #475569;
    font-size: 0.9375rem;
    margin: 0;
}

.my-plan-action {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0.4rem;
    min-width: 220px;
}

.my-plan-upgrade {
    margin-bottom: 0;
    width: auto;
    padding: 0.75rem 2rem;
}

.my-plan-action-hint {
    font-size: 0.75rem;
    color: #64748b;
    text-align: center;
}

.plan-compare-heading {
    font-size: 1.25rem;
    font-weight: 700;
    color: #1e293b;
    text-align: center;
    margin: 0 0 1.5rem;
}

/* Current-plan pricing card treatment */
.plan-card.current {
    border: 2px solid #7c3aed;
    box-shadow: 0 8px 30px rgba(124, 58, 237, 0.15);
}

.popular-badge.current-badge {
    background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
}

.plan-button.current-plan-btn,
.plan-button.current-plan-btn:disabled {
    background: #ede9fe;
    color: #6d28d9;
    border: none;
    cursor: default;
    opacity: 1;
}

@media (max-width: 640px) {
    .my-plan-card {
        flex-direction: column;
        align-items: stretch;
    }
    .my-plan-action {
        min-width: 0;
    }
}

.plan-cards-section {
    padding: 2rem 1.5rem 4rem;
    max-width: 1200px;
    margin: 0 auto;
}

.plan-cards-container {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 1.5rem;
    align-items: stretch;
}

.plan-card {
    background: #ffffff;
    border-radius: 1rem;
    padding: 2rem;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    border: 1px solid #e2e8f0;
    position: relative;
    transition: transform 0.2s, box-shadow 0.2s;
}

.plan-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
}

.plan-card.popular {
    border: 2px solid #4f46e5;
    box-shadow: 0 8px 30px rgba(79, 70, 229, 0.15);
}

.popular-badge {
    position: absolute;
    top: -12px;
    left: 50%;
    transform: translateX(-50%);
    background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
    color: white;
    font-size: 0.75rem;
    font-weight: 600;
    padding: 0.375rem 1rem;
    border-radius: 1rem;
    white-space: nowrap;
}

.plan-card-header {
    margin-bottom: 1.5rem;
}

.plan-card-header h3 {
    font-size: 1.5rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 1rem;
}

.plan-price {
    display: flex;
    align-items: baseline;
    gap: 0.25rem;
    margin-bottom: 0.75rem;
}

.starts-at {
    font-size: 0.875rem;
    color: #64748b;
}

.price {
    font-size: 3rem;
    font-weight: 800;
    color: #1e293b;
    line-height: 1;
}

.period {
    font-size: 1rem;
    color: #64748b;
    font-weight: 500;
}

.plan-description {
    color: #475569;
    font-size: 0.9375rem;
    margin-bottom: 0.25rem;
}

.plan-subtitle-text {
    color: #94a3b8;
    font-size: 0.875rem;
}

/* Plan Buttons */
.plan-button {
    width: 100%;
    padding: 0.875rem 1.5rem;
    border-radius: 0.5rem;
    font-size: 0.9375rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    margin-bottom: 1.5rem;
}

.plan-button.filled {
    background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
    color: white;
    border: none;
    box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
}

.plan-button.filled:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(79, 70, 229, 0.4);
}

.plan-button.outline {
    background: transparent;
    color: #4f46e5;
    border: 2px solid #4f46e5;
}

.plan-button.outline:hover {
    background: #4f46e5;
    color: white;
}

.plan-button.outline-light {
    background: transparent;
    color: white;
    border: 2px solid rgba(255, 255, 255, 0.5);
}

.plan-button.outline-light:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: white;
}

/* Plan Features List */
.plan-features-list {
    border-top: 1px solid #e2e8f0;
    padding-top: 1.5rem;
}

.features-title {
    font-size: 0.8125rem;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 1rem;
}

.plan-features-list ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.plan-features-list li {
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    margin-bottom: 0.75rem;
    color: #475569;
    font-size: 0.9375rem;
}

.check-icon {
    width: 1.25rem;
    height: 1.25rem;
    color: #10b981;
    flex-shrink: 0;
    margin-top: 0.125rem;
}

/* Feature Comparison Section */
.plan-comparison-section {
    padding: 4rem 1.5rem;
    max-width: 900px;
    margin: 0 auto;
}

.plan-comparison-section h2 {
    text-align: center;
    font-size: 2rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 0.5rem;
}

.section-subtitle {
    text-align: center;
    color: #64748b;
    margin-bottom: 3rem;
}

.comparison-table {
    background: #ffffff;
    border-radius: 1rem;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    border: 1px solid #e2e8f0;
}

.table-header {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
    padding: 1.25rem 1.5rem;
}

.table-header .feature-name-col {
    font-weight: 600;
    color: rgba(255, 255, 255, 0.9);
    font-size: 0.8125rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.table-header .plan-col {
    text-align: center;
    font-weight: 700;
    color: white;
    font-size: 1rem;
}

.category-section {
    border-top: 1px solid #e2e8f0;
}

.category-section:first-of-type {
    border-top: none;
}

.category-header {
    background: #f8fafc;
    padding: 1rem 1.5rem;
    font-weight: 700;
    color: #1e293b;
    font-size: 0.9375rem;
    border-bottom: 1px solid #e2e8f0;
}

.feature-row {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    padding: 1rem 1.5rem;
    border-bottom: 1px solid #f1f5f9;
    align-items: center;
    transition: background 0.15s;
}

.feature-row:hover {
    background: #f8fafc;
}

.feature-row:last-child {
    border-bottom: none;
}

.feature-name-col {
    color: #475569;
    font-size: 0.9375rem;
}

.plan-col {
    text-align: center;
    display: flex;
    justify-content: center;
}

.plan-feature-check {
    width: 1.5rem;
    height: 1.5rem;
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.plan-feature-check svg {
    width: 0.875rem;
    height: 0.875rem;
    color: white;
}

.plan-feature-cross {
    width: 1.5rem;
    height: 1.5rem;
    background: #f1f5f9;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.plan-feature-cross svg {
    width: 0.75rem;
    height: 0.75rem;
    color: #cbd5e1;
}

.plan-feature-text {
    font-size: 0.875rem;
    color: #64748b;
    font-weight: 500;
    background: #f1f5f9;
    padding: 0.25rem 0.75rem;
    border-radius: 0.375rem;
}

/* Calculator Section */
.plan-calculator-section {
    padding: 4rem 1.5rem;
    background: #ffffff;
}

.calculator-container {
    max-width: 800px;
    margin: 0 auto;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 1.5rem;
    padding: 3rem;
    border: 1px solid #e2e8f0;
}

.calculator-container h2 {
    text-align: center;
    font-size: 1.75rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 0.5rem;
}

.calculator-content {
    display: flex;
    gap: 3rem;
    margin-top: 2rem;
    align-items: start;
}

.calculator-inputs {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    min-width: 0;
}

.calculator-number-input {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    font-size: 14px;
    outline: none;
    box-sizing: border-box;
    font-variant-numeric: tabular-nums;
}

.input-group label {
    display: block;
    font-size: 0.875rem;
    font-weight: 600;
    color: #475569;
    margin-bottom: 0.75rem;
}

.input-group input[type="range"] {
    width: 100%;
    height: 8px;
    background: #e2e8f0;
    border-radius: 4px;
    outline: none;
    appearance: none;
}

.input-group input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 20px;
    height: 20px;
    background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 2px 6px rgba(79, 70, 229, 0.4);
}

.input-value {
    text-align: right;
    font-size: 1.125rem;
    font-weight: 700;
    color: #1e293b;
    margin-top: 0.5rem;
}

.calculator-result {
    background: #ffffff;
    border-radius: 1rem;
    padding: 2rem;
    text-align: center;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
}

.calculator-result strong {
    font-variant-numeric: tabular-nums;
}

.calculator-cta {
    margin-top: 0;
}

.result-label {
    font-size: 0.875rem;
    color: #64748b;
    margin-bottom: 0.5rem;
}

.result-price {
    font-size: clamp(1.75rem, 4vw, 2.5rem);
    font-weight: 800;
    color: #1e293b;
    margin-bottom: 1rem;
    min-height: 3rem;
    line-height: 1.2;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
}

.result-price span {
    font-size: 1.25rem;
    font-weight: 500;
    color: #64748b;
}

/* FAQ Section */
.plan-faq-section {
    padding: 4rem 1.5rem;
    max-width: 800px;
    margin: 0 auto;
}

.plan-faq-section h2 {
    text-align: center;
    font-size: 2rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 2.5rem;
}

.faq-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.faq-item {
    background: #ffffff;
    border-radius: 0.75rem;
    border: 1px solid #e2e8f0;
    overflow: hidden;
    cursor: pointer;
    transition: box-shadow 0.2s;
}

.faq-item:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.faq-item.expanded {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.faq-question {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.25rem 1.5rem;
    font-weight: 600;
    color: #1e293b;
}

.faq-icon {
    width: 1.25rem;
    height: 1.25rem;
    color: #64748b;
    flex-shrink: 0;
}

.faq-answer {
    padding: 0 1.5rem 1.25rem;
    color: #64748b;
    line-height: 1.6;
}

/* CTA Section */
.plan-cta-section {
    background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
    padding: 5rem 1.5rem;
    margin-top: 2rem;
}

.cta-content {
    max-width: 600px;
    margin: 0 auto;
    text-align: center;
}

.cta-content h2 {
    font-size: 2rem;
    font-weight: 700;
    color: white;
    margin-bottom: 1rem;
}

.cta-content p {
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 2rem;
    font-size: 1.125rem;
}

.cta-buttons {
    display: flex;
    gap: 1rem;
    justify-content: center;
    flex-wrap: wrap;
}

.cta-buttons .plan-button {
    width: auto;
    min-width: 160px;
    margin-bottom: 0;
}

/* Responsive */
@media (max-width: 1024px) {
    .plan-cards-container {
        grid-template-columns: 1fr;
        max-width: 420px;
        margin: 0 auto;
    }
}

@media (max-width: 768px) {

    .calculator-content {
        grid-template-columns: 1fr;
        gap: 2rem;
    }

    .table-header,
    .feature-row {
        grid-template-columns: 1.5fr 1fr 1fr;
        padding: 0.875rem 1rem;
    }

    .feature-name-col {
        font-size: 0.8125rem;
    }

    .cta-buttons {
        flex-direction: column;
        align-items: center;
    }

    .cta-buttons .plan-button {
        width: 100%;
        max-width: 280px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/billing/plan.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;IACI,iBAAiB;IACjB,yBAAyB;IACzB,8FAA8F;AAClG;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,SAAS;IACT,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,6DAA6D;AACjE;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,6DAA6D;IAC7D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,kCAAkC;IAClC,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;IAC1B,wCAAwC;AAC5C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB,oDAAoD;AACpD;IACI,iBAAiB;IACjB,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,6DAA6D;IAC7D,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,wCAAwC;AACxC;IACI,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA;IACI,6DAA6D;AACjE;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,UAAU;AACd;;AAEA;IACI;QACI,sBAAsB;QACtB,oBAAoB;IACxB;IACA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,0CAA0C;IAC1C,yBAAyB;IACzB,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,2BAA2B;IAC3B,6DAA6D;IAC7D,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,WAAW;IACX,wBAAwB;IACxB,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,6CAA6C;AACjD;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,0CAA0C;AAC9C;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB;IACI,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,sBAAsB;IACtB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,cAAc;IACd,oBAAoB;AACxB;;AAEA,+BAA+B;AAC/B;IACI,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,0CAA0C;IAC1C,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,6DAA6D;IAC7D,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,oBAAoB;IACpB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,oBAAoB;IACpB,gCAAgC;IAChC,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,cAAc;IACd,6DAA6D;IAC7D,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA,uBAAuB;AACvB;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,6DAA6D;IAC7D,qBAAqB;IACrB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IAEb,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,6DAA6D;IAC7D,kBAAkB;IAClB,eAAe;IACf,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,gBAAgB;AAChB;IACI,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,6DAA6D;IAC7D,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,eAAe;AACf;IACI;QACI,0BAA0B;QAC1B,gBAAgB;QAChB,cAAc;IAClB;AACJ;;AAEA;;IAEI;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;;QAEI,oCAAoC;QACpC,sBAAsB;IAC1B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;AACJ","sourcesContent":["/* Plan Page Styles */\n.plan-page {\n    min-height: 100vh;\n    background-color: #f8fafc;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;\n}\n\n.plan-loading {\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 1rem;\n    color: #64748b;\n}\n\n.plan-loading-spinner {\n    width: 40px;\n    height: 40px;\n    border: 3px solid #e2e8f0;\n    border-top-color: #4f46e5;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.plan-geo-alert {\n    max-width: 1200px;\n    margin: 0 auto 1.5rem;\n    padding: 1rem 1.25rem;\n    border-radius: 12px;\n    background: #fef3c7;\n    border: 1px solid #f59e0b;\n    color: #92400e;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1rem;\n}\n\n.plan-geo-alert p {\n    margin: 0;\n    flex: 1;\n    min-width: 220px;\n}\n\n.plan-geo-alert-btn {\n    border: none;\n    border-radius: 8px;\n    padding: 0.5rem 1rem;\n    background: #d97706;\n    color: #fff;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.plan-geo-alert-btn:hover {\n    background: #b45309;\n}\n\n.plan-button:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n}\n\n.plan-header {\n    text-align: center;\n    padding: 2.5rem 1.5rem 2rem;\n    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n}\n\n.plan-header h1 {\n    font-size: clamp(1.5rem, 3vw, 2.25rem);\n    font-weight: 700;\n    color: #1e293b;\n    margin-bottom: 0.75rem;\n    line-height: 1.25;\n}\n\n.gradient-text {\n    background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n.plan-subtitle {\n    font-size: 1.125rem;\n    color: #64748b;\n    margin-bottom: 0.5rem;\n}\n\n.plan-region-hint {\n    font-size: 0.9375rem;\n    color: #64748b;\n    margin-bottom: 1.5rem;\n}\n\n.plan-metrics-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.plan-metrics-list li {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.5rem;\n    margin-bottom: 0.625rem;\n    font-size: 0.875rem;\n    color: #475569;\n    line-height: 1.4;\n}\n\n.calculator-breakdown {\n    font-size: 0.8125rem;\n    color: #64748b;\n    margin: 0.5rem 0 1rem;\n}\n\n.calculator-usage-breakdown {\n    list-style: none;\n    margin: 0 0 1.25rem;\n    padding: 0;\n    text-align: left;\n    border-top: 1px solid #e2e8f0;\n    padding-top: 1rem;\n}\n\n.calculator-usage-breakdown li {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n    gap: 0.5rem;\n    padding: 0.4rem 0;\n    font-size: 0.8125rem;\n    color: #94a3b8;\n    min-height: 1.5rem;\n}\n\n.calculator-usage-breakdown li.has-usage {\n    color: #64748b;\n}\n\n.calculator-usage-breakdown li.has-usage .breakdown-calc strong {\n    color: #1e293b;\n}\n\n.calculator-usage-breakdown .breakdown-label {\n    font-weight: 500;\n    flex: 1 1 auto;\n    min-width: 0;\n}\n\n.calculator-usage-breakdown .breakdown-calc {\n    text-align: right;\n    font-variant-numeric: tabular-nums;\n    flex: 0 0 11.5rem;\n    white-space: nowrap;\n}\n\n.calculator-usage-breakdown .breakdown-calc strong {\n    font-weight: 600;\n    color: #cbd5e1;\n}\n\n/* Billing Toggle */\n.billing-toggle {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.75rem;\n    background: #ffffff;\n    padding: 0.5rem 1rem;\n    border-radius: 2rem;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.billing-toggle span {\n    font-size: 0.875rem;\n    /* color: #94a3b8; */\n    transition: color 0.2s;\n}\n\n.billing-toggle span.active {\n    color: #1e293b;\n    font-weight: 600;\n}\n\n.toggle-switch {\n    width: 48px;\n    height: 26px;\n    background: #e2e8f0;\n    border: none;\n    border-radius: 13px;\n    cursor: pointer;\n    position: relative;\n    transition: background 0.2s;\n}\n\n.toggle-switch:hover {\n    background: #cbd5e1;\n}\n\n.toggle-slider {\n    position: absolute;\n    top: 3px;\n    left: 3px;\n    width: 20px;\n    height: 20px;\n    background: #ffffff;\n    border-radius: 50%;\n    transition: transform 0.2s;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.toggle-slider.annual {\n    transform: translateX(22px);\n}\n\n.save-badge {\n    background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n    color: white;\n    font-size: 0.75rem;\n    padding: 0.25rem 0.5rem;\n    border-radius: 1rem;\n    margin-left: 0.25rem;\n    font-weight: 600;\n}\n\n/* Plan Cards Section */\n/* ── \"Your current plan\" card (My Plan header) ── */\n.my-plan-section {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 0.5rem 1.5rem 0;\n}\n\n.my-plan-card {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1.5rem;\n    flex-wrap: wrap;\n    padding: 1.5rem 1.75rem;\n    border-radius: 1rem;\n    background: linear-gradient(135deg, #f5f3ff 0%, #eef2ff 100%);\n    border: 1px solid #ddd6fe;\n}\n\n.my-plan-info {\n    min-width: 0;\n}\n\n.my-plan-eyebrow {\n    display: inline-block;\n    font-size: 0.75rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: #7c3aed;\n    margin-bottom: 0.35rem;\n}\n\n.my-plan-name {\n    font-size: 1.5rem;\n    font-weight: 700;\n    color: #1e293b;\n    margin: 0 0 0.25rem;\n}\n\n.my-plan-price {\n    display: flex;\n    align-items: baseline;\n    gap: 0.25rem;\n    margin-bottom: 0.35rem;\n}\n\n.my-plan-price-amount {\n    font-size: 1.75rem;\n    font-weight: 800;\n    color: #1e293b;\n    line-height: 1;\n}\n\n.my-plan-price-period {\n    font-size: 0.9375rem;\n    color: #64748b;\n    font-weight: 500;\n}\n\n.my-plan-desc {\n    color: #475569;\n    font-size: 0.9375rem;\n    margin: 0;\n}\n\n.my-plan-action {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.4rem;\n    min-width: 220px;\n}\n\n.my-plan-upgrade {\n    margin-bottom: 0;\n    width: auto;\n    padding: 0.75rem 2rem;\n}\n\n.my-plan-action-hint {\n    font-size: 0.75rem;\n    color: #64748b;\n    text-align: center;\n}\n\n.plan-compare-heading {\n    font-size: 1.25rem;\n    font-weight: 700;\n    color: #1e293b;\n    text-align: center;\n    margin: 0 0 1.5rem;\n}\n\n/* Current-plan pricing card treatment */\n.plan-card.current {\n    border: 2px solid #7c3aed;\n    box-shadow: 0 8px 30px rgba(124, 58, 237, 0.15);\n}\n\n.popular-badge.current-badge {\n    background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);\n}\n\n.plan-button.current-plan-btn,\n.plan-button.current-plan-btn:disabled {\n    background: #ede9fe;\n    color: #6d28d9;\n    border: none;\n    cursor: default;\n    opacity: 1;\n}\n\n@media (max-width: 640px) {\n    .my-plan-card {\n        flex-direction: column;\n        align-items: stretch;\n    }\n    .my-plan-action {\n        min-width: 0;\n    }\n}\n\n.plan-cards-section {\n    padding: 2rem 1.5rem 4rem;\n    max-width: 1200px;\n    margin: 0 auto;\n}\n\n.plan-cards-container {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 1.5rem;\n    align-items: stretch;\n}\n\n.plan-card {\n    background: #ffffff;\n    border-radius: 1rem;\n    padding: 2rem;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n    border: 1px solid #e2e8f0;\n    position: relative;\n    transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.plan-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);\n}\n\n.plan-card.popular {\n    border: 2px solid #4f46e5;\n    box-shadow: 0 8px 30px rgba(79, 70, 229, 0.15);\n}\n\n.popular-badge {\n    position: absolute;\n    top: -12px;\n    left: 50%;\n    transform: translateX(-50%);\n    background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);\n    color: white;\n    font-size: 0.75rem;\n    font-weight: 600;\n    padding: 0.375rem 1rem;\n    border-radius: 1rem;\n    white-space: nowrap;\n}\n\n.plan-card-header {\n    margin-bottom: 1.5rem;\n}\n\n.plan-card-header h3 {\n    font-size: 1.5rem;\n    font-weight: 700;\n    color: #1e293b;\n    margin-bottom: 1rem;\n}\n\n.plan-price {\n    display: flex;\n    align-items: baseline;\n    gap: 0.25rem;\n    margin-bottom: 0.75rem;\n}\n\n.starts-at {\n    font-size: 0.875rem;\n    color: #64748b;\n}\n\n.price {\n    font-size: 3rem;\n    font-weight: 800;\n    color: #1e293b;\n    line-height: 1;\n}\n\n.period {\n    font-size: 1rem;\n    color: #64748b;\n    font-weight: 500;\n}\n\n.plan-description {\n    color: #475569;\n    font-size: 0.9375rem;\n    margin-bottom: 0.25rem;\n}\n\n.plan-subtitle-text {\n    color: #94a3b8;\n    font-size: 0.875rem;\n}\n\n/* Plan Buttons */\n.plan-button {\n    width: 100%;\n    padding: 0.875rem 1.5rem;\n    border-radius: 0.5rem;\n    font-size: 0.9375rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s;\n    margin-bottom: 1.5rem;\n}\n\n.plan-button.filled {\n    background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);\n    color: white;\n    border: none;\n    box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);\n}\n\n.plan-button.filled:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(79, 70, 229, 0.4);\n}\n\n.plan-button.outline {\n    background: transparent;\n    color: #4f46e5;\n    border: 2px solid #4f46e5;\n}\n\n.plan-button.outline:hover {\n    background: #4f46e5;\n    color: white;\n}\n\n.plan-button.outline-light {\n    background: transparent;\n    color: white;\n    border: 2px solid rgba(255, 255, 255, 0.5);\n}\n\n.plan-button.outline-light:hover {\n    background: rgba(255, 255, 255, 0.1);\n    border-color: white;\n}\n\n/* Plan Features List */\n.plan-features-list {\n    border-top: 1px solid #e2e8f0;\n    padding-top: 1.5rem;\n}\n\n.features-title {\n    font-size: 0.8125rem;\n    font-weight: 600;\n    color: #64748b;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    margin-bottom: 1rem;\n}\n\n.plan-features-list ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.plan-features-list li {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.75rem;\n    margin-bottom: 0.75rem;\n    color: #475569;\n    font-size: 0.9375rem;\n}\n\n.check-icon {\n    width: 1.25rem;\n    height: 1.25rem;\n    color: #10b981;\n    flex-shrink: 0;\n    margin-top: 0.125rem;\n}\n\n/* Feature Comparison Section */\n.plan-comparison-section {\n    padding: 4rem 1.5rem;\n    max-width: 900px;\n    margin: 0 auto;\n}\n\n.plan-comparison-section h2 {\n    text-align: center;\n    font-size: 2rem;\n    font-weight: 700;\n    color: #1e293b;\n    margin-bottom: 0.5rem;\n}\n\n.section-subtitle {\n    text-align: center;\n    color: #64748b;\n    margin-bottom: 3rem;\n}\n\n.comparison-table {\n    background: #ffffff;\n    border-radius: 1rem;\n    overflow: hidden;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n    border: 1px solid #e2e8f0;\n}\n\n.table-header {\n    display: grid;\n    grid-template-columns: 2fr 1fr 1fr;\n    background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);\n    padding: 1.25rem 1.5rem;\n}\n\n.table-header .feature-name-col {\n    font-weight: 600;\n    color: rgba(255, 255, 255, 0.9);\n    font-size: 0.8125rem;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n\n.table-header .plan-col {\n    text-align: center;\n    font-weight: 700;\n    color: white;\n    font-size: 1rem;\n}\n\n.category-section {\n    border-top: 1px solid #e2e8f0;\n}\n\n.category-section:first-of-type {\n    border-top: none;\n}\n\n.category-header {\n    background: #f8fafc;\n    padding: 1rem 1.5rem;\n    font-weight: 700;\n    color: #1e293b;\n    font-size: 0.9375rem;\n    border-bottom: 1px solid #e2e8f0;\n}\n\n.feature-row {\n    display: grid;\n    grid-template-columns: 2fr 1fr 1fr;\n    padding: 1rem 1.5rem;\n    border-bottom: 1px solid #f1f5f9;\n    align-items: center;\n    transition: background 0.15s;\n}\n\n.feature-row:hover {\n    background: #f8fafc;\n}\n\n.feature-row:last-child {\n    border-bottom: none;\n}\n\n.feature-name-col {\n    color: #475569;\n    font-size: 0.9375rem;\n}\n\n.plan-col {\n    text-align: center;\n    display: flex;\n    justify-content: center;\n}\n\n.plan-feature-check {\n    width: 1.5rem;\n    height: 1.5rem;\n    background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.plan-feature-check svg {\n    width: 0.875rem;\n    height: 0.875rem;\n    color: white;\n}\n\n.plan-feature-cross {\n    width: 1.5rem;\n    height: 1.5rem;\n    background: #f1f5f9;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.plan-feature-cross svg {\n    width: 0.75rem;\n    height: 0.75rem;\n    color: #cbd5e1;\n}\n\n.plan-feature-text {\n    font-size: 0.875rem;\n    color: #64748b;\n    font-weight: 500;\n    background: #f1f5f9;\n    padding: 0.25rem 0.75rem;\n    border-radius: 0.375rem;\n}\n\n/* Calculator Section */\n.plan-calculator-section {\n    padding: 4rem 1.5rem;\n    background: #ffffff;\n}\n\n.calculator-container {\n    max-width: 800px;\n    margin: 0 auto;\n    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n    border-radius: 1.5rem;\n    padding: 3rem;\n    border: 1px solid #e2e8f0;\n}\n\n.calculator-container h2 {\n    text-align: center;\n    font-size: 1.75rem;\n    font-weight: 700;\n    color: #1e293b;\n    margin-bottom: 0.5rem;\n}\n\n.calculator-content {\n    display: flex;\n    gap: 3rem;\n    margin-top: 2rem;\n    align-items: start;\n}\n\n.calculator-inputs {\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n    min-width: 0;\n}\n\n.calculator-number-input {\n    width: 100%;\n    padding: 8px 12px;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    font-size: 14px;\n    outline: none;\n    box-sizing: border-box;\n    font-variant-numeric: tabular-nums;\n}\n\n.input-group label {\n    display: block;\n    font-size: 0.875rem;\n    font-weight: 600;\n    color: #475569;\n    margin-bottom: 0.75rem;\n}\n\n.input-group input[type=\"range\"] {\n    width: 100%;\n    height: 8px;\n    background: #e2e8f0;\n    border-radius: 4px;\n    outline: none;\n    -webkit-appearance: none;\n    appearance: none;\n}\n\n.input-group input[type=\"range\"]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    width: 20px;\n    height: 20px;\n    background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);\n    border-radius: 50%;\n    cursor: pointer;\n    box-shadow: 0 2px 6px rgba(79, 70, 229, 0.4);\n}\n\n.input-value {\n    text-align: right;\n    font-size: 1.125rem;\n    font-weight: 700;\n    color: #1e293b;\n    margin-top: 0.5rem;\n}\n\n.calculator-result {\n    background: #ffffff;\n    border-radius: 1rem;\n    padding: 2rem;\n    text-align: center;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    min-width: 0;\n}\n\n.calculator-result strong {\n    font-variant-numeric: tabular-nums;\n}\n\n.calculator-cta {\n    margin-top: 0;\n}\n\n.result-label {\n    font-size: 0.875rem;\n    color: #64748b;\n    margin-bottom: 0.5rem;\n}\n\n.result-price {\n    font-size: clamp(1.75rem, 4vw, 2.5rem);\n    font-weight: 800;\n    color: #1e293b;\n    margin-bottom: 1rem;\n    min-height: 3rem;\n    line-height: 1.2;\n    font-variant-numeric: tabular-nums;\n    white-space: nowrap;\n}\n\n.result-price span {\n    font-size: 1.25rem;\n    font-weight: 500;\n    color: #64748b;\n}\n\n/* FAQ Section */\n.plan-faq-section {\n    padding: 4rem 1.5rem;\n    max-width: 800px;\n    margin: 0 auto;\n}\n\n.plan-faq-section h2 {\n    text-align: center;\n    font-size: 2rem;\n    font-weight: 700;\n    color: #1e293b;\n    margin-bottom: 2.5rem;\n}\n\n.faq-list {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.faq-item {\n    background: #ffffff;\n    border-radius: 0.75rem;\n    border: 1px solid #e2e8f0;\n    overflow: hidden;\n    cursor: pointer;\n    transition: box-shadow 0.2s;\n}\n\n.faq-item:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.faq-item.expanded {\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n.faq-question {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1.25rem 1.5rem;\n    font-weight: 600;\n    color: #1e293b;\n}\n\n.faq-icon {\n    width: 1.25rem;\n    height: 1.25rem;\n    color: #64748b;\n    flex-shrink: 0;\n}\n\n.faq-answer {\n    padding: 0 1.5rem 1.25rem;\n    color: #64748b;\n    line-height: 1.6;\n}\n\n/* CTA Section */\n.plan-cta-section {\n    background: linear-gradient(135deg, #1e293b 0%, #334155 100%);\n    padding: 5rem 1.5rem;\n    margin-top: 2rem;\n}\n\n.cta-content {\n    max-width: 600px;\n    margin: 0 auto;\n    text-align: center;\n}\n\n.cta-content h2 {\n    font-size: 2rem;\n    font-weight: 700;\n    color: white;\n    margin-bottom: 1rem;\n}\n\n.cta-content p {\n    color: rgba(255, 255, 255, 0.7);\n    margin-bottom: 2rem;\n    font-size: 1.125rem;\n}\n\n.cta-buttons {\n    display: flex;\n    gap: 1rem;\n    justify-content: center;\n    flex-wrap: wrap;\n}\n\n.cta-buttons .plan-button {\n    width: auto;\n    min-width: 160px;\n    margin-bottom: 0;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n    .plan-cards-container {\n        grid-template-columns: 1fr;\n        max-width: 420px;\n        margin: 0 auto;\n    }\n}\n\n@media (max-width: 768px) {\n\n    .calculator-content {\n        grid-template-columns: 1fr;\n        gap: 2rem;\n    }\n\n    .table-header,\n    .feature-row {\n        grid-template-columns: 1.5fr 1fr 1fr;\n        padding: 0.875rem 1rem;\n    }\n\n    .feature-name-col {\n        font-size: 0.8125rem;\n    }\n\n    .cta-buttons {\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .cta-buttons .plan-button {\n        width: 100%;\n        max-width: 280px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
